import { apiService } from './axios.client';

export const PlanEndPoints = {
    setPlanSession: function (input, callback) {
        apiService.post('/PlanSession/setPlanSession', input)
            .then((response) => callback(response, input))
            .catch(callback());
    },
    updatePlanSession: function (input, callback) {
        apiService.post('/PlanSession/updatePlanSession', input)
            .then((response) => callback(response, input))
            .catch(error => alert(error.response.data.message));
    },
    getPlanSessionById: function (input, callback) {
        apiService.get('/PlanSession/getPlanSessionById', input)
            .then((response) => callback(response))
            .catch(error => alert(error));
    },
    getAllPlanSession: function (input, callback) {
        apiService.get('/PlanSession/getAllPlanSession', input)
            .then((response) => callback(response))
            .catch(error => alert(error));
    },
    deletePlanSession: function (input, callback) {
        apiService.post('/PlanSession/deletePlanSession', input)
            .then((response) => callback(response))
            .catch(error => alert(error));
    },
    importPlanSession: function (input, callback) {
        apiService.post('/PlanSession/importPlanSession', input)
            .then((response) => callback(response, input))
            .catch(error => alert(error));
    },
    exportPlanSession: function (input, callback) {
        apiService.get('/PlanSession/exportPlanSession', input)
            .then((response) => callback(response))
            .catch(error => alert(error));
    },
    uploadReportCapture: function (input) {
        return apiService.post('/Report/uploadReportCapture', input);
    },
    fetchReportHTML: function (input, callback) {
        apiService.post('/Report/fetchReportHTML', input)
            .then((response) => callback(response))
            .catch(error => alert(error));
    },
    getReportElements: function (input, callback) {
        apiService.post('/Report/getReportElements', input)
            .then((response) => callback(response))
            .catch(error => alert(error));
    },
    saveReportTemplate: function (input, callback) {
        apiService.post('/Report/saveReportTemplate', input)
            .then((response) => callback(response))
            .catch(error => alert(error));
    },
    deleteReportTemplate: function (input, callback) {
        apiService.post('/Report/deleteReportTemplate', input)
            .then((response) => callback(response))
            .catch(error => alert(error));
    },
    uploadTestPDF: function (input, callback) {
        apiService.post('/PlanSession/uploadTestPDF', input)
            .then((response) => callback(response))
            .catch(error => alert(error));
    },
    getImageElements: function (input, callback) {
        apiService.get('/Report/GetReportIamgeElements', input)
            .then((response) => callback(response))
            .catch(error => alert(error));
    },
    getTemplates: function (input, callback) {
        apiService.get('/Report/GetTemplates', input)
            .then((response) => callback(response))
            .catch(error => alert(error));
    }
}